module.exports = __webpack_public_path__ + "img/angle_165.ace55367.jpg";